export default "__VITE_ASSET__BXjrfPfy__"